<template>
  <div data-v-79b5fac2="" data-v-e5781868="" class="games mainContent top50">
    <div data-v-79b5fac2="" class="top">
      <div data-v-79b5fac2="" class="swipper">
        <div data-v-170a62a4="" data-v-79b5fac2="" class="gameSwipper swiper-container-horizontal">
          <div class="swiper-wrapper" style="transform: translate3d(-1980px, 0px, 0px); transition-duration: 0ms">
            <div data-v-170a62a4="" class="swiper-slide" style="width: 990px">
              <div data-v-170a62a4="" class="banner-img-wrapper"><img data-v-170a62a4="" src="/static/image/banner-games-usdt-2c76955d42d7ae9e7a212963209316233.png_.webp" class="banner-img" /></div>
            </div>
            <div data-v-170a62a4="" class="swiper-slide swiper-slide-prev" style="width: 990px">
              <div data-v-170a62a4="" class="banner-img-wrapper"><img data-v-170a62a4="" src="/static/image/banner-games-usdt-2c76955d42d7ae9e7a212963209316233.png_.webp" class="banner-img" /></div>
            </div>
            <div data-v-170a62a4="" class="swiper-slide swiper-slide-active" style="width: 990px">
              <div data-v-170a62a4="" class="banner-img-wrapper"><img data-v-170a62a4="" src="/static/image/banner-games-usdt-2c76955d42d7ae9e7a212963209316233.png_.webp" class="banner-img" /></div>
            </div>
          </div>
          <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
        </div>
      </div>
      <div data-v-79b5fac2="" class="bonus">
        <div data-v-79b5fac2="" class="bonus1">
          <div data-v-d88722e4="" data-v-79b5fac2="" class="bouns">
            <p data-v-d88722e4="">AG电游奖金池 (CNY)</p>
            <div data-v-d88722e4="" id="jackpot-ag" class="bonusAmount">1,000,001.20</div>
          </div>
        </div>
        <div data-v-79b5fac2="" class="bouns2">
          <div data-v-d88722e4="" data-v-79b5fac2="" class="bouns">
            <p data-v-d88722e4="">PT电游奖金池 (CNY)</p>
            <div data-v-d88722e4="" id="jackpot-pt" class="bonusAmount">2,000,001.20</div>
          </div>
        </div>
      </div>
    </div>
    <div data-v-79b5fac2="" class="content">
      <div data-v-79b5fac2="" class="left" style="width: 100%">
        <div data-v-79b5fac2="" class="tab">
          <div data-v-cec8e5ea="" data-v-79b5fac2="" class="tabs">
            <div data-v-cec8e5ea="" class="item active">
              <svg data-v-338e1447="" data-v-cec8e5ea="" aria-hidden="true" class="svg-icon tabsvg">
                <use data-v-338e1447="" xlink:href="#icon-gameRecommend"></use>
              </svg>
              {{ $store.state.appInfo.title }}推荐
            </div>
<!--            <div data-v-cec8e5ea="" class="item">
              <svg data-v-338e1447="" data-v-cec8e5ea="" aria-hidden="true" class="svg-icon tabsvg">
                <use data-v-338e1447="" xlink:href="#icon-gameLobby"></use>
              </svg>
              游戏大厅
            </div> -->
     
          </div>
        </div>
        <div data-v-79b5fac2="" class="filter" style="display: none">
          <div data-v-27c51983="" data-v-79b5fac2="" class="filter">
            <div data-v-27c51983="" class="filter-group">
              <label data-v-27c51983="">游戏平台：</label>
              <a data-v-27c51983="" href="javascript:void (0);" :class="gamecode == 'obgdy' ? 'active' : ''" @click="changgamecode('obgdy')"> OB电子 </a>
              <a data-v-27c51983="" href="javascript:void (0);" :class="gamecode == 'fgdz' ? 'active' : ''" @click="changgamecode('fgdz')"> FG电子 </a>
              <a data-v-27c51983="" href="javascript:void (0);" :class="gamecode == 'pp' ? 'active' : ''" @click="changgamecode('pp')"> PP电子 </a>
              <a data-v-27c51983="" href="javascript:void (0);" :class="gamecode == 'ae' ? 'active' : ''" @click="changgamecode('ae')"> AE电子 </a>
            </div>
          </div>
        </div>
        <div data-v-79b5fac2="" class="gameitems">
          <div data-v-79b5fac2="" class="item" style="" v-for="(item, index) in gameList" :key="index" v-if="bigShow && item.app_state == 1">
            <div data-v-3d756204="" data-v-79b5fac2="" class="gameItem big">
              <div data-v-3d756204="" class="img">
                <div data-v-3d756204="" class="itemmask">
                  <div data-v-3d756204="" class="inner">
                    <a data-v-3d756204="" class="btn" v-if="item.app_state == 1" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
                      立即游戏
                      <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                    <a v-else>维护中</a>
                  </div>
                </div>
                <img data-v-3d756204="" :src="`/static/image/concise/${item.platform_name}dz.png`" lazy="loaded" />
              </div>
              <div data-v-3d756204="" class="hotvalue">
                <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconfirevalue">
                  <use data-v-338e1447="" xlink:href="#icon-iconfirevalue"></use></svg
                ><span data-v-3d756204="">{{ item.name }}</span>
              </div>
            </div>
          </div>

          <div data-v-79b5fac2="" v-if="!bigShow && gamecode == 'obgdy'" class="item" v-for="(item, index) in obgdyList" :key="index">
            <div data-v-3d756204="" data-v-79b5fac2="" class="gameItem">
              <div data-v-3d756204="" class="img">
                <div data-v-3d756204="" class="itemmask">
                  <div data-v-3d756204="" class="inner">
                    <a data-v-3d756204="" class="btn" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
                      立即游戏
                      <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
                <img data-v-3d756204="" alt="" :src="item.gamepic" lazy="loaded" />
              </div>
              <div data-v-3d756204="" class="favourite">
                <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon gameFavourite">
                  <use data-v-338e1447="" xlink:href="#icon-gamefavourite"></use>
                </svg>
              </div>
              <div data-v-3d756204="" class="hotvalue">
                <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconfirevalue">
                  <use data-v-338e1447="" xlink:href="#icon-iconfirevalue"></use></svg
                ><span data-v-3d756204="" style="padding-right: 6px">{{ item.gamename }}</span>
              </div>
            </div>
          </div>
          <div data-v-79b5fac2="" v-if="!bigShow && gamecode == 'fgdz'" class="item" v-for="(item, index) in fgdzList" :key="index">
            <div data-v-3d756204="" data-v-79b5fac2="" class="gameItem">
              <div data-v-3d756204="" class="img">
                <div data-v-3d756204="" class="itemmask">
                  <div data-v-3d756204="" class="inner">
                    <a data-v-3d756204="" class="btn" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
                      立即游戏
                      <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
                <img data-v-3d756204="" alt="" :src="item.gamepic" lazy="loaded" />
              </div>
              <div data-v-3d756204="" class="favourite">
                <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon gameFavourite">
                  <use data-v-338e1447="" xlink:href="#icon-gamefavourite"></use>
                </svg>
              </div>
              <div data-v-3d756204="" class="hotvalue">
                <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconfirevalue">
                  <use data-v-338e1447="" xlink:href="#icon-iconfirevalue"></use></svg
                ><span data-v-3d756204="" style="padding-right: 6px">{{ item.gamename }}</span>
              </div>
            </div>
          </div>
          <div data-v-79b5fac2="" v-if="!bigShow && gamecode == 'pp'" class="item" v-for="(item, index) in ppList" :key="index">
            <div data-v-3d756204="" data-v-79b5fac2="" class="gameItem">
              <div data-v-3d756204="" class="img">
                <div data-v-3d756204="" class="itemmask">
                  <div data-v-3d756204="" class="inner">
                    <a data-v-3d756204="" class="btn" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
                      立即游戏
                      <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
                <img data-v-3d756204="" alt="" :src="item.gamepic" lazy="loaded" />
              </div>
              <div data-v-3d756204="" class="favourite">
                <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon gameFavourite">
                  <use data-v-338e1447="" xlink:href="#icon-gamefavourite"></use>
                </svg>
              </div>
              <div data-v-3d756204="" class="hotvalue">
                <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconfirevalue">
                  <use data-v-338e1447="" xlink:href="#icon-iconfirevalue"></use></svg
                ><span data-v-3d756204="" style="padding-right: 6px">{{ item.gamename }}</span>
              </div>
            </div>
          </div>
          <div data-v-79b5fac2="" v-if="!bigShow && gamecode == 'ae'" class="item" v-for="(item, index) in aeList" :key="index">
            <div data-v-3d756204="" data-v-79b5fac2="" class="gameItem">
              <div data-v-3d756204="" class="img">
                <div data-v-3d756204="" class="itemmask">
                  <div data-v-3d756204="" class="inner">
                    <a data-v-3d756204="" class="btn" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
                      立即游戏
                      <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconArrow">
                        <use data-v-338e1447="" xlink:href="#icon-iconArrow"></use></svg
                    ></a>
                  </div>
                </div>
                <img data-v-3d756204="" alt="" :src="item.gamepic" lazy="loaded" />
              </div>
              <div data-v-3d756204="" class="favourite">
                <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon gameFavourite">
                  <use data-v-338e1447="" xlink:href="#icon-gamefavourite"></use>
                </svg>
              </div>
              <div data-v-3d756204="" class="hotvalue">
                <svg data-v-338e1447="" data-v-3d756204="" aria-hidden="true" class="svg-icon iconfirevalue">
                  <use data-v-338e1447="" xlink:href="#icon-iconfirevalue"></use></svg
                ><span data-v-3d756204="" style="padding-right: 6px">{{ item.gamename }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'electronics',
  data() {
    return { obgdyList: [], ppList: [], fgdzList: [], aeList: [], gamecode: 'obgdy', bigShow: true, gameList: [] };
  },
  created() {
    let that = this;
    if (this.$route.query) {
      that.gamecode = this.$route.query.type || that.gamecode;
    }
    that.getGameList();
    that.gamelistBycode();
  },
  methods: {
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'concise' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    changgamecode(code) {
      let that = this;
      if (code == that.gamecode) {
        return;
      }

      that.gamecode = code;
      that.gamelistBycode();
    },
    gamelistBycode() {
      let that = this;
      let name = that.gamecode + 'List';
      if (that[name].length > 0) {
        return;
      }
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/gamelistBycode', { gamecode: that.gamecode })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that[name] = res.data;
          }
          setTimeout(() => {
            that.$parent.hideLoading();
          }, 2000);
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });

    var gameSwipper = new Swiper('.swipper .gameSwipper', {
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.gameSwipper .swiper-pagination',
        clickable: true,
      },
    });
    $('.tabs .item:eq(0)').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      $('.filter ,.gameitems .nofavdata').css('display', 'none');
      $('.gameitems .item').css('display', '');
      $('.gameitems .item:eq(0),.gameitems .item:eq(1)').css('display', '');
      that.bigShow = true;
    });
    $('.tabs .item:eq(1)').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      $('.filter').css('display', '');
      $('.gameitems .nofavdata').css('display', 'none');
      $('.gameitems .item').css('display', '');
      $('.gameitems .item:eq(0),.gameitems .item:eq(1)').css('display', 'none');
      that.bigShow = false;
    });
    $('.filter-group a').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
    });
    $('.tabs .item:eq(2)').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      $('.filter').css('display', 'none');
      $('.gameitems .nofavdata').css('display', '');
      $('.gameitems .item').css('display', 'none');
    });

    $('.listTabs .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
    });

    var options = {
      useEasing: true,
      useGrouping: true, 
      separator: ',', 
      decimal: '.', 
      prefix: '', 
      suffix: '', 
    };

    
    new CountUp('jackpot-ag', 1000000, 2000000, 2, 50000000, options).start();
    new CountUp('jackpot-pt', 2000000, 3000000, 2, 50000000, options).start();
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-0b4f6f8a.b95eea1a.css';
.filter[data-v-27c51983][data-v-08a50d9b] {
  height: auto;
}
.gameItem .hotvalue[data-v-3d756204][data-v-08a50d9b] {
  width: 2rem;
}

.gameItem.big[data-v-3d756204][data-v-08a50d9b][data-v-08a50d9b][data-v-08a50d9b] {
  width: 2.85rem !important;
  height: 3.2rem !important;
}
.gameItem.big {
  width: 2.85rem !important;
  height: 3.2rem !important;
}
.games .content .left .gameitems[data-v-79b5fac2][data-v-08a50d9b] {
  justify-content: space-evenly !important;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/electronics.vue